interface MandalaBgProps {
  opacity?: number;
  withOverlay?: boolean;
}

/**
 * Reusable rotating mandala backdrop.
 * Spins slowly (90s) with a breathing opacity loop (6s).
 * Pure decoration — pointer-events: none, aria-hidden.
 */
export default function MandalaBg({ opacity = 0.08, withOverlay = true }: MandalaBgProps) {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      {withOverlay && (
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse 60% 60% at 50% 50%, rgba(201,123,42,0.06) 0%, transparent 70%)",
          }}
        />
      )}
      <div
        className="mandala-bg flex items-center justify-center"
        style={{ opacity }}
      >
        <svg
          viewBox="0 0 600 600"
          className="w-[min(95vw,820px)] h-[min(95vw,820px)] text-manuscript"
          xmlns="http://www.w3.org/2000/svg"
        >
          {[290, 230, 170, 110, 50].map((r) => (
            <circle key={r} cx="300" cy="300" r={r} stroke="currentColor" strokeWidth="0.4" fill="none" />
          ))}
          {Array.from({ length: 16 }).map((_, i) => {
            const a = (i * (360 / 16) * Math.PI) / 180;
            return (
              <line
                key={i}
                x1="300"
                y1="300"
                x2={300 + 290 * Math.cos(a)}
                y2={300 + 290 * Math.sin(a)}
                stroke="currentColor"
                strokeWidth="0.3"
              />
            );
          })}
          {Array.from({ length: 8 }).map((_, i) => {
            const a = ((i * 45 + 22.5) * Math.PI) / 180;
            return (
              <circle
                key={`p${i}`}
                cx={300 + 190 * Math.cos(a)}
                cy={300 + 190 * Math.sin(a)}
                r="22"
                stroke="currentColor"
                strokeWidth="0.35"
                fill="none"
              />
            );
          })}
        </svg>
      </div>
    </div>
  );
}
